import config from '@/config';
import { checkWrapperType } from '@/utilities/helpers/wrapperHelpers';
import { useTranslation } from 'react-i18next';

const PluginErrorBody = () => {
  const { t } = useTranslation();
  const { isMobile } = checkWrapperType();

  const translation = isMobile ? 'GeoguardNotInstalled' : 'PLCNotInstalled';
  return (
    <>
      <p>{t(`${translation}.allowCasino`)}</p>
      <p>
        {t(`${translation}.safelyDownload`)}
        <a
          className="more-details"
          href={config?.geoComply?.help}
          target="_blank"
          rel="noopener noreferrer"
        >
          {t(`${translation}.here`)}
        </a>
      </p>
    </>
  );
};

export default PluginErrorBody;
